// src/hooks/useSupport.js
//
// Контакты поддержки — С СЕРВЕРА, а не из кода.
//
// Причина: механизма обязательных обновлений пока нет. Захардкоженный номер
// означал бы, что человек на старом APK навсегда остался со старым контактом —
// и не смог бы связаться именно тогда, когда это нужнее всего.
//
// Значения в коде — только запасные, на случай, если сервер недоступен
// (нет интернета, лежит бэкенд). Лучше показать старый контакт, чем ничего.

import { useEffect, useState } from 'react';
import { app as appApi } from '../api';

// Запасной вариант — используется, только если сервер не ответил
const FALLBACK = {
  whatsapp: 'https://wa.me/996704240282',
  telegram: 'https://t.me/alsatuu_support',
  email: null,
};

let cached = null;   // в рамках сессии тянем один раз

export function useSupport() {
  const [contacts, setContacts] = useState(cached || FALLBACK);
  const [loaded, setLoaded] = useState(Boolean(cached));

  useEffect(() => {
    if (cached) return;
    let alive = true;
    (async () => {
      try {
        const r = await appApi.support();
        if (!alive) return;
        // Пустые поля не затирают запасные
        const merged = {
          whatsapp: r?.whatsapp || FALLBACK.whatsapp,
          telegram: r?.telegram || FALLBACK.telegram,
          email: r?.email || null,
        };
        cached = merged;
        setContacts(merged);
      } catch (e) {
        // сервер недоступен — остаёмся на запасных
      }
      if (alive) setLoaded(true);
    })();
    return () => { alive = false; };
  }, []);

  return { contacts, loaded };
}
